import * as yup from "yup";
import { Formik, Form as FormikForm } from "formik";
import { Button as BSButton, FloatingLabel, Form } from "react-bootstrap";
import { VoidPreAuthRequestDTO } from "../../../../data/entities";

export interface VoidFormProps {
  paymentId: number;
  onSubmit: (voidRequest: VoidPreAuthRequestDTO) => void;
  submitRef: React.RefObject<HTMLButtonElement>;
}

export function VoidForm({ paymentId, onSubmit, submitRef }: Readonly<VoidFormProps>) {
  return (
    <Formik
      initialValues={{ reason: "", confirmAction: false }}
      validationSchema={yup.object().shape({
        confirmAction: yup.boolean().oneOf([true], "You must confirm before proceeding."),
      })}
      onSubmit={(values) => {
        onSubmit({
          paymentId: paymentId,
          CancellationReason: values.reason || null,
        });
      }}
    >
      {({ handleSubmit, handleChange, values, touched, errors }) => (
        <FormikForm noValidate onSubmit={handleSubmit} className="d-flex flex-column flex-grow-1">
          <FloatingLabel label="Reason for cancellation (optional)" className="mb-3">
            <Form.Control
              as="textarea"
              name="reason"
              value={values.reason}
              onChange={handleChange}
              style={{ minHeight: "150px" }}
            />
          </FloatingLabel>

          {/* Confirmation checkbox at the bottom */}
          <div className="mt-auto mb-3 p-3 rounded bg-warning bg-opacity-10 border border-warning">
            <Form.Check
              type="checkbox"
              name="confirmAction"
              label="I understand that canceling this pre-authorization will release the hold and the customer will not be charged."
              checked={values.confirmAction}
              onChange={handleChange}
              isInvalid={touched.confirmAction && !!errors.confirmAction}
            />
          </div>

          <BSButton type="submit" className="d-none" ref={submitRef} />
        </FormikForm>
      )}
    </Formik>
  );
}

export default VoidForm;